import object from "./object";
import AlertMixin from "./alert";

export default [object, AlertMixin];
